import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAdFromUrlState } from '../../interfaces/state.interfaces';

const initialState: IAdFromUrlState = {
    isActive: false,
    loading: false,
    isGenerating: false,
};

const adFromUrlSlice = createSlice({
    name: 'adFromUrl',
    initialState,
    reducers: {
        SetAdFromUrlActive(state, action: PayloadAction<boolean>) {
            state.isActive = action.payload;
        },
        SetAdFromUrlLoading(state, action: PayloadAction<boolean>) {
            state.loading = action.payload;
        },
        SetAdFromUrlGenerating(state, action: PayloadAction<boolean>) {
            state.isGenerating = action.payload;
        },
        SetAdFromUrlFlowInactive(state) {
            state.isActive = false;
            state.loading = false;
            state.isGenerating = false;
        },
        SetAdFromUrlInitialState(state) {
            state.isActive = false;
            state.loading = false;
            state.isGenerating = false;
        },
    },
});

export const {
    SetAdFromUrlActive,
    SetAdFromUrlLoading,
    SetAdFromUrlGenerating,
    SetAdFromUrlFlowInactive,
    SetAdFromUrlInitialState,
} = adFromUrlSlice.actions;

export const adFromUrlReducer = adFromUrlSlice.reducer;
